import React from 'react';

const GiftsPage = () => {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-indigo-600 mb-6">Gifts</h2>
      <p className="text-gray-600">Gift ideas and tracking will be displayed here.</p>
    </div>
  );
};

export default GiftsPage;
